import { TextField, styled } from "@mui/material";
import React from "react";

const InputStyled = styled(TextField)`
  // padding: 0px;
  // width: 100%;
  // border-radius: 5px;

  // border: 1px solid gray;
  // height: 20px;
  && {
    padding: 0px;
    width: 100%;
    border-radius: 5px;
    
    .MuiInputBase-input {
      height: 10px; 
      border: none;
    }
  }
`;

function Input({
  type,
  value,
  onChange,
  placeholder,
  className,
  style,
  autofocus,
  name
}) {
  return (
    <InputStyled
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      style={style}
      autoFocus={autofocus}
      name={name}
    />
  );
}

export default Input;
